<div class="auth-wrapper">
  <mat-card class="auth-card" appearance="outlined">
    <mat-card-content class="auth-content">
      <h1 class="headline">{{ 'emailVerified.headline' | transloco }}</h1>
      <p class="supporting">{{ 'emailVerified.supporting' | transloco }}</p>

      @if (returnUrl) {
        <button mat-flat-button color="primary" type="button" (click)="continueToApp()">
          {{ 'emailVerified.continueTo' | transloco }} {{ appName || ('common.signIn' | transloco) }}
        </button>
      } @else {
        <button mat-flat-button color="primary" type="button" [routerLink]="['/']" queryParamsHandling="preserve">
          {{ 'emailVerified.goToSignIn' | transloco }}
        </button>
      }
    </mat-card-content>
  </mat-card>
</div>
